import { web3APIClient } from "@/api/api";

export const solana_network = import.meta.env.PROD ? "mainnet-beta" : "devnet";

/**
 * Initializes a payment
 * @param {Object} params - Payment parameters
 * @param {string} params.personaId
 * @param {string} params.userAddress
 * @param {string} params.currency
 * @param {number} params.amountUsd
 * @returns {Promise<PaymentResponse>}
 */
export const initPayment = async ({
  personaId,
  userAddress,
  currency,
  amountUsd,
}: {
  personaId: string;
  userAddress: string;
  currency: string;
  amountUsd: number;
}) => {
  try {
    const response = await web3APIClient.post(`/api/payments/init`, {
      personaId,
      userAddress,
      currency,
      amountUsd,
      solana_network,
    });

    if (response.status !== 200) {
      throw new Error(`Failed to init payment: ${response.status}`);
    }

    return response.data;
  } catch (error) {
    console.error("Error in initPayment:", error);
    throw error;
  }
};

/**
 * Confirms a payment
 * @param {Object} params - Confirmation parameters
 * @param {string} params.paymentId
 * @param {string} params.txSignature
 * @returns {Promise<{message: string, paymentId: string, txSignature: string}>}
 */
export const confirmPayment = async ({
  paymentId,
  txSignature,
}: {
  paymentId: string;
  txSignature: any;
}) => {
  try {
    const response = await web3APIClient.post(`/api/payments/confirm`, {
      paymentId,
      txSignature,
      solana_network,
    });

    if (response.status !== 200) {
      throw new Error(
        `Failed to confirm payment: ${response.data?.detail || response.status}`,
      );
    }

    return response.data;
  } catch (error) {
    console.error("Error in confirmPayment:", error);
    throw error;
  }
};
